<mat-select
  #select
  [id]="matSelectId"
  [(value)]="value"
  [ngModel]="value"
  [disabled]="disabled"
  [placeholder]="placeholder"
  (selectionChange)="changeValue()"
  (openedChange)="openedChange.emit($event)"
  [class.black-border]="select.focused"
  class="form-control"
  [class.disabled]="disabled"
  [multiple]="multiple"
>
  <mat-option class="mat-primary">
    <ngx-mat-select-search
      placeholderLabel=""
      noEntriesFoundLabel="Nothing found"
      [hideClearSearchButton]="true"
      [formControl]="filterCtrl"
    ></ngx-mat-select-search>
  </mat-option>

  @for (option of filteredOptions; track option.id; let i = $index) {
  <mat-option
    [value]="option.id"
    [class.hidden]="!option.text || option.deprecated"
    id="{{ 'option-' + i }}"
    class="mat-primary"
  >
    {{ option.text }}
  </mat-option>
  }
</mat-select>
